// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 460) return "static/chunks/460-21c383698e883267fce4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"318":"d97f10c46fe66d665e93","792":"732a67c75fa244605445","837":"9eb13ce37e062852acc4","917":"a1cd7eb955b41c6efd2d"}[chunkId] + ".js";
};